<ng-container *ngIf="multiEdit$ | async as multiEdit; else selectEntityPrompt" class="multi-edit-product-editor">
  <p translate [translateParams]="{ '0': multiEdit.selectedEntitiesCount }">UI.MultiEdit.EditingMultipleProducts</p>

  <app-multi-edit-entity-editor
    [entity]="multiEdit.combinedEntity"
    [entityType]="multiEdit.type"
    [entityForm]="formGroup"
    (propertyChange)="propertyChanged($event)"
  ></app-multi-edit-entity-editor>
</ng-container>

<ng-template #selectEntityPrompt>
  <div class="none-chosen">
    <p>{{ 'UI.MultiEdit.NoComponentChosen' | translate }}.</p>
  </div>
</ng-template>
